import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_PLAYERSEASONS,
  SET_ERROR,
  SET_PLAYERSEASONS,
} from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  seasons: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PLAYERSEASONS:
      return {
        ...state,
        isReady: true,
        isError: false,
        seasons: action.data,
      };
    case RESET_PLAYERSEASONS:
      return initialState;
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectPlayerSeasons = createSelector(getState, (n) =>
  n.seasons.reverse()
);

reducerRegistry.register(REDUCER_NAME, reducer);
